<template>
  <li>
    <div class="text-nowrap d-flex">
      <div
        class="d-inline-block align-middle"
        :style="`padding-left: ${this.depth * 1.5}rem`"
      ></div>
      <div
        v-if="hasNested"
        :hidden="node.values"
        :style="{ visibility: !node.values ? 'hidden' : 'auto', top: '-1px' }"
        class="d-inline-block align-middle mr-2 position-relative"
        @click.stop="toggleChild(node)"
      >
        <svg-icon
          v-if="state.expanded"
          icon="minus"
          class="icon-xxs cursor-pointer"
        />
        <svg-icon v-else icon="plus" class="icon-xxs cursor-pointer" />
      </div>
      <div class="d-inline-block align-middle text-wrap">
        <b-form-checkbox
          :checked="state.checked"
          :indeterminate="node.state.indeterminate"
          @change.native="checkChanged"
        >
          <slot name="checkbox-title" :node="node">
            {{ node.name }}
          </slot>
        </b-form-checkbox>
      </div>
    </div>
    <ul class="list-unstyled" v-if="state.expanded">
      <template v-for="child in node.values">
        <tree-row
          :depth="depth + 1"
          :key="child.name"
          :node="child"
          :range="range"
          :ranges="ranges"
          :all="all"
          :parent-node="node"
          :has-nested="hasNested"
          @emit-node-checked="emitNodeChecked"
        >
          <template
            v-for="slot in Object.keys($scopedSlots)"
            v-slot:[slot]="scope"
          >
            <slot :name="slot" v-bind="scope" />
          </template>
        </tree-row>
      </template>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'TreeRow',

  props: {
    node: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    parentNode: {
      type: [Object, null],
      default: null
    },
    hasNested: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
    ranges: {
      type: Object,
      default: null
    },
    all: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      state: {
        checked: this.node.state.checked,
        expanded: this.node.state.expanded
      }
    };
  },

  methods: {
    toggleChild() {
      this.state.expanded = !this.state.expanded;
    },
    checkChanged(e) {
      e.preventDefault();
      let ranges = this.ranges;

      if (this.range) {
        if (ranges.first.value === null) {
          ranges.first.value = this.all.indexOf(this.node);
          ranges.first.state = !this.state.checked;
        } else {
          ranges.second = this.all.indexOf(this.node);
        }
      }

      this.state.checked = !this.state.checked;

      this.emitNodeChecked({
        node: this.node,
        newState: this.state.checked,
        ranges
      });
    },
    emitNodeChecked(data) {
      this.$emit('emit-node-checked', data);
    }
  },

  watch: {
    'node.state.checked': {
      handler(val) {
        this.state.checked = val;
      }
    },
    'node.state.expanded': {
      handler(val) {
        this.state.expanded = val;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
li {
  word-break: break-all;
  user-select: none;
}
</style>
